/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


const compare = (lhs, rhs) =>
{
  const lhsLength = lhs.length;
  const rhsLength = rhs.length;

  const length = Math.min(lhsLength, rhsLength);

  for (let i = 0; i < length; ++i)
  {
    let lhsItem = lhs[i];
    let rhsItem = rhs[i];

    // Null / undefined compare.
    if (lhsItem == null && rhsItem != null)
    {
      return - 1;
    }

    if (lhsItem != null && rhsItem == null)
    {
      return 1;
    }

    // Array compare (recursive).
    if (lhsItem instanceof Array && rhsItem instanceof Array)
    {
      let result = compare(lhsItem, rhsItem);

      if (result !== 0)
      {
        return result;
      }
    }

    // Compare objects via equals, less.
    if (lhsItem.equals && lhsItem.less && rhsItem.equals && rhsItem.less)
    {
      if (lhsItem.less(rhsItem))
      {
        return - 1;
      }

      if (!lhsItem.less(rhsItem) && !lhsItem.equals(rhsItem))
      {
        return 1;
      }
    }

    // Compare primitives via <, > (objects need valueOf).
    else
    {
      if (lhsItem < rhsItem)
      {
        return - 1;
      }

      if (lhsItem > rhsItem)
      {
        return 1;
      }
    }
  }

  return lhsLength - rhsLength;
};


export default compare;
